import React, { useState, useEffect } from 'react';
import { 
    FaTimes, FaArrowLeft, FaArrowRight, FaCheck, FaPaperPlane, 
    FaClock, FaCalendarAlt, FaSync, FaUsers, FaFileAlt, FaEnvelope, FaSpinner
} from 'react-icons/fa';
import { campaignAPI, templateAPI, segmentAPI } from './campaignService';

const styles = {
    container: {
        color: '#FFFFFF',
        minHeight: '500px',
        display: 'flex',
        flexDirection: 'column'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '24px 30px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        margin: 0
    },
    closeBtn: {
        background: 'transparent',
        border: 'none',
        color: '#94A3B8',
        fontSize: '20px',
        cursor: 'pointer'
    },
    steps: {
        display: 'flex',
        padding: '20px 30px',
        background: 'rgba(0, 0, 0, 0.2)',
        gap: '0'
    },
    step: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '12px 16px',
        position: 'relative'
    },
    stepNumber: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: '600',
        background: 'rgba(100, 116, 139, 0.3)',
        color: '#94A3B8'
    },
    stepNumberActive: {
        background: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
        color: '#FFFFFF'
    },
    stepNumberDone: {
        background: '#10b981',
        color: '#FFFFFF'
    },
    stepLabel: {
        fontSize: '14px',
        color: 'rgba(255, 255, 255, 0.6)'
    },
    stepLabelActive: {
        color: '#FFFFFF',
        fontWeight: '500'
    },
    content: {
        flex: 1,
        padding: '30px',
        overflowY: 'auto'
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '20px 30px',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
    },
    btn: {
        padding: '12px 24px',
        borderRadius: '8px',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    primaryBtn: {
        background: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
        color: '#FFFFFF'
    },
    secondaryBtn: {
        background: 'rgba(100, 116, 139, 0.2)',
        border: '1px solid rgba(100, 116, 139, 0.4)',
        color: '#94A3B8'
    },
    successBtn: {
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: '#FFFFFF'
    },
    input: {
        width: '100%',
        padding: '14px 16px',
        background: 'rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        color: '#FFFFFF',
        fontSize: '14px',
        boxSizing: 'border-box'
    },
    textarea: {
        width: '100%',
        padding: '14px 16px',
        background: 'rgba(0, 0, 0, 0.3)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        color: '#FFFFFF',
        fontSize: '14px',
        minHeight: '80px',
        resize: 'vertical',
        fontFamily: 'inherit',
        boxSizing: 'border-box'
    },
    label: {
        display: 'block',
        fontSize: '14px',
        color: 'rgba(255, 255, 255, 0.7)',
        marginBottom: '8px'
    },
    section: {
        marginBottom: '24px'
    },
    card: {
        background: 'rgba(0, 0, 0, 0.2)',
        borderRadius: '12px',
        padding: '20px',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    cardActive: {
        borderColor: '#8b5cf6',
        background: 'rgba(139, 92, 246, 0.1)'
    },
    cardTitle: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#FFFFFF',
        marginBottom: '4px'
    },
    cardDesc: {
        fontSize: '13px',
        color: 'rgba(255, 255, 255, 0.6)'
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '16px'
    },
    scheduleOptions: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '16px',
        marginBottom: '24px'
    },
    scheduleCard: {
        background: 'rgba(0, 0, 0, 0.2)',
        borderRadius: '12px',
        padding: '24px',
        textAlign: 'center',
        border: '1px solid rgba(255, 255, 255, 0.05)',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
    },
    scheduleCardActive: {
        borderColor: '#8b5cf6',
        background: 'rgba(139, 92, 246, 0.1)'
    },
    scheduleIcon: {
        fontSize: '32px',
        color: '#8b5cf6',
        marginBottom: '12px'
    },
    summaryCard: {
        background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(16, 185, 129, 0.1) 100%)',
        borderRadius: '16px',
        padding: '30px',
        border: '1px solid rgba(139, 92, 246, 0.2)'
    },
    summaryRow: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '12px 0',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
    },
    summaryLabel: {
        color: 'rgba(255, 255, 255, 0.6)',
        fontSize: '14px'
    },
    summaryValue: {
        color: '#FFFFFF',
        fontSize: '14px',
        fontWeight: '500'
    },
    row: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px'
    },
    emptyState: {
        textAlign: 'center',
        padding: '40px',
        color: 'rgba(255, 255, 255, 0.5)'
    }
};

const STEPS = [
    { id: 1, label: 'Basic Info' },
    { id: 2, label: 'Template' },
    { id: 3, label: 'Audience' },
    { id: 4, label: 'Schedule' },
    { id: 5, label: 'Review' }
];

const CampaignWizard = ({ expertId, templates, segments, onClose, onComplete }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [saving, setSaving] = useState(false);
    const [prebuiltTemplates, setPrebuiltTemplates] = useState([]);
    const [prebuiltSegments, setPrebuiltSegments] = useState([]);
    const [loadingPrebuilt, setLoadingPrebuilt] = useState(true);
    
    // Fetch prebuilt templates and segments on mount
    useEffect(() => {
        const fetchPrebuilt = async () => {
            try {
                const [templatesData, segmentsData] = await Promise.all([
                    templateAPI.getPrebuiltTemplates(),
                    segmentAPI.getPrebuiltSegments()
                ]);
                setPrebuiltTemplates(templatesData || []);
                setPrebuiltSegments(segmentsData || []);
            } catch (error) {
                console.error('Error fetching prebuilt data:', error);
            } finally {
                setLoadingPrebuilt(false);
            }
        };
        fetchPrebuilt();
    }, []);
    
    // Campaign data
    const [campaignData, setCampaignData] = useState({
        name: '',
        description: '',
        templateId: '',
        isPrebuiltTemplate: false, // Track if selected template is prebuilt
        segmentId: '',
        isPrebuiltSegment: false, // Track if selected segment is prebuilt
        scheduleType: 'immediate',
        scheduledFor: '',
        recurrence: {
            pattern: 'weekly',
            daysOfWeek: [1], // Monday
            time: '09:00',
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
    });

    const selectedTemplate = campaignData.isPrebuiltTemplateTemplate 
        ? prebuiltTemplates.find(t => t.id === campaignData.templateId)
        : templates.find(t => t._id === campaignData.templateId);
    const selectedSegment = campaignData.isPrebuiltTemplateSegment
        ? prebuiltSegments.find(s => s.id === campaignData.segmentId)
        : segments.find(s => s._id === campaignData.segmentId);

    const updateData = (field, value) => {
        setCampaignData(prev => ({ ...prev, [field]: value }));
    };

    const canProceed = () => {
        switch (currentStep) {
            case 1:
                return campaignData.name.trim().length > 0;
            case 2:
                return campaignData.templateId !== '';
            case 3:
                return campaignData.segmentId !== '';
            case 4:
                if (campaignData.scheduleType === 'scheduled') {
                    return campaignData.scheduledFor !== '';
                }
                return true;
            default:
                return true;
        }
    };

    const handleNext = () => {
        if (currentStep < 5) {
            setCurrentStep(currentStep + 1);
        }
    };

    const handleBack = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleCreate = async () => {
        setSaving(true);
        try {
            let templateIdToUse = campaignData.templateId;
            let segmentIdToUse = campaignData.segmentId;
            
            // If using a prebuilt template, first create it as a custom template
            if (campaignData.isPrebuiltTemplateTemplate) {
                const prebuilt = prebuiltTemplates.find(t => t.id === campaignData.templateId);
                if (prebuilt) {
                    const savedTemplate = await templateAPI.createFromPrebuilt(
                        expertId, 
                        campaignData.templateId,
                        { name: `${prebuilt.name} - ${campaignData.name}` }
                    );
                    templateIdToUse = savedTemplate._id;
                }
            }
            
            // If using a prebuilt segment, first create it as a custom segment
            if (campaignData.isPrebuiltTemplateSegment) {
                const savedSegment = await segmentAPI.createFromPrebuilt(
                    expertId,
                    campaignData.segmentId
                );
                segmentIdToUse = savedSegment._id;
            }
            
            const payload = {
                name: campaignData.name,
                description: campaignData.description,
                templateId: templateIdToUse,
                segmentId: segmentIdToUse,
                scheduleType: campaignData.scheduleType,
                ...(campaignData.scheduleType === 'scheduled' && {
                    scheduledFor: new Date(campaignData.scheduledFor)
                }),
                ...(campaignData.scheduleType === 'recurring' && {
                    recurrence: {
                        ...campaignData.recurrence,
                        startDate: new Date()
                    }
                })
            };

            const campaign = await campaignAPI.createCampaign(expertId, payload);
            
            // If immediate, send now
            if (campaignData.scheduleType === 'immediate') {
                if (window.confirm('Campaign created! Do you want to send it now?')) {
                    await campaignAPI.sendCampaign(expertId, campaign._id);
                }
            }

            onComplete();
        } catch (error) {
            console.error('Error creating campaign:', error);
            alert('Failed to create campaign: ' + (error.response?.data?.error || error.message));
        } finally {
            setSaving(false);
        }
    };

    const renderStep1 = () => (
        <div>
            <h3 style={{ marginTop: 0, marginBottom: '24px' }}>Campaign Details</h3>
            
            <div style={styles.section}>
                <label style={styles.label}>Campaign Name *</label>
                <input 
                    type="text"
                    style={styles.input}
                    value={campaignData.name}
                    onChange={(e) => updateData('name', e.target.value)}
                    placeholder="e.g., March Newsletter, Visa Expiry Reminder"
                />
            </div>

            <div style={styles.section}>
                <label style={styles.label}>Description</label>
                <textarea 
                    style={styles.textarea}
                    value={campaignData.description}
                    onChange={(e) => updateData('description', e.target.value)}
                    placeholder="Brief description of this campaign's purpose"
                />
            </div>
        </div>
    );

    const selectTemplate = (templateId, isPrebuiltTemplate = false) => {
        setCampaignData(prev => ({
            ...prev,
            templateId,
            isPrebuiltTemplate
        }));
    };

    const selectSegment = (segmentId, isPrebuiltSegment = false) => {
        setCampaignData(prev => ({
            ...prev,
            segmentId,
            isPrebuiltSegment
        }));
    };

    const renderStep2 = () => {
        const allTemplatesEmpty = templates.length === 0 && prebuiltTemplates.length === 0;
        
        return (
            <div>
                <h3 style={{ marginTop: 0, marginBottom: '24px' }}>Select Email Template</h3>
                
                {loadingPrebuilt ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: 'rgba(255,255,255,0.6)' }}>
                        <FaSpinner className="spin" style={{ fontSize: '24px', marginBottom: '12px' }} />
                        <p>Loading templates...</p>
                    </div>
                ) : allTemplatesEmpty ? (
                    <div style={styles.emptyState}>
                        <FaFileAlt style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }} />
                        <p>No templates available. Please create a template first.</p>
                    </div>
                ) : (
                    <div>
                        {/* Prebuilt Templates Section */}
                        {prebuiltTemplates.length > 0 && (
                            <div style={{ marginBottom: '32px' }}>
                                <h4 style={{ 
                                    fontSize: '14px', 
                                    color: 'rgba(255,255,255,0.7)', 
                                    marginBottom: '16px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Pre-built Templates
                                </h4>
                                <div style={styles.grid}>
                                    {prebuiltTemplates.map(template => (
                                        <div
                                            key={template.id}
                                            style={{
                                                ...styles.card,
                                                ...(campaignData.templateId === template.id && campaignData.isPrebuiltTemplate 
                                                    ? styles.cardActive : {})
                                            }}
                                            onClick={() => selectTemplate(template.id, true)}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <div>
                                                    <div style={styles.cardTitle}>{template.name}</div>
                                                    <div style={styles.cardDesc}>{template.description}</div>
                                                </div>
                                                {campaignData.templateId === template.id && campaignData.isPrebuiltTemplate && (
                                                    <FaCheck style={{ color: '#8b5cf6', fontSize: '18px' }} />
                                                )}
                                            </div>
                                            <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
                                                <span style={{
                                                    padding: '4px 10px',
                                                    background: 'rgba(139, 92, 246, 0.2)',
                                                    borderRadius: '12px',
                                                    fontSize: '11px',
                                                    color: '#8b5cf6'
                                                }}>
                                                    {template.category}
                                                </span>
                                                <span style={{
                                                    padding: '4px 10px',
                                                    background: 'rgba(16, 185, 129, 0.2)',
                                                    borderRadius: '12px',
                                                    fontSize: '11px',
                                                    color: '#10b981'
                                                }}>
                                                    Ready to use
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Custom Templates Section */}
                        {templates.length > 0 && (
                            <div>
                                <h4 style={{ 
                                    fontSize: '14px', 
                                    color: 'rgba(255,255,255,0.7)', 
                                    marginBottom: '16px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Your Custom Templates
                                </h4>
                                <div style={styles.grid}>
                                    {templates.map(template => (
                                        <div
                                            key={template._id}
                                            style={{
                                                ...styles.card,
                                                ...(campaignData.templateId === template._id && !campaignData.isPrebuiltTemplate 
                                                    ? styles.cardActive : {})
                                            }}
                                            onClick={() => selectTemplate(template._id, false)}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <div>
                                                    <div style={styles.cardTitle}>{template.name}</div>
                                                    <div style={styles.cardDesc}>{template.subject}</div>
                                                </div>
                                                {campaignData.templateId === template._id && !campaignData.isPrebuiltTemplate && (
                                                    <FaCheck style={{ color: '#8b5cf6', fontSize: '18px' }} />
                                                )}
                                            </div>
                                            <div style={{ marginTop: '12px' }}>
                                                <span style={{
                                                    padding: '4px 10px',
                                                    background: 'rgba(139, 92, 246, 0.2)',
                                                    borderRadius: '12px',
                                                    fontSize: '11px',
                                                    color: '#8b5cf6'
                                                }}>
                                                    {template.category}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    };

    const renderStep3 = () => {
        const allSegmentsEmpty = segments.length === 0 && prebuiltSegments.length === 0;
        
        return (
            <div>
                <h3 style={{ marginTop: 0, marginBottom: '24px' }}>Select Audience</h3>
                
                {loadingPrebuilt ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: 'rgba(255,255,255,0.6)' }}>
                        <FaSpinner className="spin" style={{ fontSize: '24px', marginBottom: '12px' }} />
                        <p>Loading segments...</p>
                    </div>
                ) : allSegmentsEmpty ? (
                    <div style={styles.emptyState}>
                        <FaUsers style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }} />
                        <p>No segments available. Please create a segment first.</p>
                    </div>
                ) : (
                    <div>
                        {/* Prebuilt Segments Section */}
                        {prebuiltSegments.length > 0 && (
                            <div style={{ marginBottom: '32px' }}>
                                <h4 style={{ 
                                    fontSize: '14px', 
                                    color: 'rgba(255,255,255,0.7)', 
                                    marginBottom: '16px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Pre-built Audience Segments
                                </h4>
                                <div style={styles.grid}>
                                    {prebuiltSegments.map(segment => (
                                        <div
                                            key={segment.id}
                                            style={{
                                                ...styles.card,
                                                ...(campaignData.segmentId === segment.id && campaignData.isPrebuiltSegment 
                                                    ? styles.cardActive : {})
                                            }}
                                            onClick={() => selectSegment(segment.id, true)}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <div>
                                                    <div style={styles.cardTitle}>{segment.name}</div>
                                                    <div style={styles.cardDesc}>{segment.description}</div>
                                                </div>
                                                {campaignData.segmentId === segment.id && campaignData.isPrebuiltSegment && (
                                                    <FaCheck style={{ color: '#8b5cf6', fontSize: '18px' }} />
                                                )}
                                            </div>
                                            <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
                                                <span style={{
                                                    padding: '4px 10px',
                                                    background: 'rgba(16, 185, 129, 0.2)',
                                                    borderRadius: '12px',
                                                    fontSize: '11px',
                                                    color: '#10b981'
                                                }}>
                                                    Ready to use
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Custom Segments Section */}
                        {segments.length > 0 && (
                            <div>
                                <h4 style={{ 
                                    fontSize: '14px', 
                                    color: 'rgba(255,255,255,0.7)', 
                                    marginBottom: '16px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Your Custom Segments
                                </h4>
                                <div style={styles.grid}>
                                    {segments.map(segment => (
                                        <div
                                            key={segment._id}
                                            style={{
                                                ...styles.card,
                                                ...(campaignData.segmentId === segment._id && !campaignData.isPrebuiltSegment 
                                                    ? styles.cardActive : {})
                                            }}
                                            onClick={() => selectSegment(segment._id, false)}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <div>
                                                    <div style={styles.cardTitle}>{segment.name}</div>
                                                    <div style={styles.cardDesc}>{segment.description || 'No description'}</div>
                                                </div>
                                                {campaignData.segmentId === segment._id && !campaignData.isPrebuiltSegment && (
                                                    <FaCheck style={{ color: '#8b5cf6', fontSize: '18px' }} />
                                                )}
                                            </div>
                                            <div style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <FaUsers style={{ fontSize: '14px', color: '#8b5cf6' }} />
                                                <span style={{ fontSize: '14px', color: '#8b5cf6', fontWeight: '600' }}>
                                                    ~{segment.estimatedCount || '?'} recipients
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    };

    const renderStep4 = () => (
        <div>
            <h3 style={{ marginTop: 0, marginBottom: '24px' }}>When to Send</h3>
            
            <div style={styles.scheduleOptions}>
                <div
                    style={{
                        ...styles.scheduleCard,
                        ...(campaignData.scheduleType === 'immediate' ? styles.scheduleCardActive : {})
                    }}
                    onClick={() => updateData('scheduleType', 'immediate')}
                >
                    <FaPaperPlane style={styles.scheduleIcon} />
                    <div style={styles.cardTitle}>Send Now</div>
                    <div style={styles.cardDesc}>Send immediately after creation</div>
                </div>

                <div
                    style={{
                        ...styles.scheduleCard,
                        ...(campaignData.scheduleType === 'scheduled' ? styles.scheduleCardActive : {})
                    }}
                    onClick={() => updateData('scheduleType', 'scheduled')}
                >
                    <FaCalendarAlt style={styles.scheduleIcon} />
                    <div style={styles.cardTitle}>Schedule</div>
                    <div style={styles.cardDesc}>Send at a specific date & time</div>
                </div>

                <div
                    style={{
                        ...styles.scheduleCard,
                        ...(campaignData.scheduleType === 'recurring' ? styles.scheduleCardActive : {})
                    }}
                    onClick={() => updateData('scheduleType', 'recurring')}
                >
                    <FaSync style={styles.scheduleIcon} />
                    <div style={styles.cardTitle}>Recurring</div>
                    <div style={styles.cardDesc}>Send repeatedly on a schedule</div>
                </div>
            </div>

            {/* Schedule options */}
            {campaignData.scheduleType === 'scheduled' && (
                <div style={styles.section}>
                    <label style={styles.label}>Schedule Date & Time</label>
                    <input 
                        type="datetime-local"
                        style={styles.input}
                        value={campaignData.scheduledFor}
                        onChange={(e) => updateData('scheduledFor', e.target.value)}
                        min={new Date().toISOString().slice(0, 16)}
                    />
                </div>
            )}

            {campaignData.scheduleType === 'recurring' && (
                <div>
                    <div style={styles.section}>
                        <label style={styles.label}>Repeat Pattern</label>
                        <select
                            style={styles.input}
                            value={campaignData.recurrence.pattern}
                            onChange={(e) => setCampaignData(prev => ({
                                ...prev,
                                recurrence: { ...prev.recurrence, pattern: e.target.value }
                            }))}
                        >
                            <option value="daily">Daily</option>
                            <option value="weekly">Weekly</option>
                            <option value="biweekly">Every 2 Weeks</option>
                            <option value="monthly">Monthly</option>
                        </select>
                    </div>

                    {campaignData.recurrence.pattern === 'weekly' && (
                        <div style={styles.section}>
                            <label style={styles.label}>Days of Week</label>
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, index) => (
                                    <button
                                        key={day}
                                        style={{
                                            padding: '10px 16px',
                                            background: campaignData.recurrence.daysOfWeek?.includes(index)
                                                ? 'rgba(139, 92, 246, 0.3)'
                                                : 'rgba(0, 0, 0, 0.3)',
                                            border: campaignData.recurrence.daysOfWeek?.includes(index)
                                                ? '1px solid #8b5cf6'
                                                : '1px solid rgba(255, 255, 255, 0.1)',
                                            borderRadius: '8px',
                                            color: '#FFFFFF',
                                            cursor: 'pointer',
                                            fontSize: '13px'
                                        }}
                                        onClick={() => {
                                            const current = campaignData.recurrence.daysOfWeek || [];
                                            const newDays = current.includes(index)
                                                ? current.filter(d => d !== index)
                                                : [...current, index];
                                            setCampaignData(prev => ({
                                                ...prev,
                                                recurrence: { ...prev.recurrence, daysOfWeek: newDays }
                                            }));
                                        }}
                                    >
                                        {day}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    <div style={styles.section}>
                        <label style={styles.label}>Time to Send</label>
                        <input 
                            type="time"
                            style={{...styles.input, maxWidth: '200px'}}
                            value={campaignData.recurrence.time}
                            onChange={(e) => setCampaignData(prev => ({
                                ...prev,
                                recurrence: { ...prev.recurrence, time: e.target.value }
                            }))}
                        />
                    </div>
                </div>
            )}
        </div>
    );

    const renderStep5 = () => (
        <div>
            <h3 style={{ marginTop: 0, marginBottom: '24px' }}>Review Your Campaign</h3>
            
            <div style={styles.summaryCard}>
                <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Campaign Name</span>
                    <span style={styles.summaryValue}>{campaignData.name}</span>
                </div>
                <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Template</span>
                    <span style={styles.summaryValue}>{selectedTemplate?.name || 'Not selected'}</span>
                </div>
                <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Subject Line</span>
                    <span style={styles.summaryValue}>{selectedTemplate?.subject || '-'}</span>
                </div>
                <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Audience</span>
                    <span style={styles.summaryValue}>
                        {selectedSegment?.name || 'Not selected'}
                        {selectedSegment && ` (~${selectedSegment.estimatedCount || '?'} recipients)`}
                    </span>
                </div>
                <div style={styles.summaryRow}>
                    <span style={styles.summaryLabel}>Schedule</span>
                    <span style={styles.summaryValue}>
                        {campaignData.scheduleType === 'immediate' && 'Send immediately'}
                        {campaignData.scheduleType === 'scheduled' && `Scheduled for ${new Date(campaignData.scheduledFor).toLocaleString()}`}
                        {campaignData.scheduleType === 'recurring' && `Recurring ${campaignData.recurrence.pattern}`}
                    </span>
                </div>
                <div style={{ ...styles.summaryRow, borderBottom: 'none' }}>
                    <span style={styles.summaryLabel}>Description</span>
                    <span style={styles.summaryValue}>{campaignData.description || 'None'}</span>
                </div>
            </div>

            <div style={{ 
                marginTop: '24px', 
                padding: '16px', 
                background: 'rgba(16, 185, 129, 0.1)', 
                borderRadius: '8px',
                border: '1px solid rgba(16, 185, 129, 0.2)'
            }}>
                <p style={{ margin: 0, color: '#10b981', fontSize: '14px' }}>
                    <FaCheck style={{ marginRight: '8px' }} />
                    Your campaign is ready! Click "Create Campaign" to proceed.
                </p>
            </div>
        </div>
    );

    return (
        <>
        <style>{`
            @keyframes spin {
                from { transform: rotate(0deg); }
                to { transform: rotate(360deg); }
            }
            .spin {
                animation: spin 1s linear infinite;
            }
        `}</style>
        <div style={styles.container}>
            {/* Header */}
            <div style={styles.header}>
                <h2 style={styles.title}>
                    <FaPaperPlane style={{ marginRight: '12px', color: '#8b5cf6' }} />
                    Create Campaign
                </h2>
                <button style={styles.closeBtn} onClick={onClose}>
                    <FaTimes />
                </button>
            </div>

            {/* Steps indicator */}
            <div style={styles.steps}>
                {STEPS.map((step, index) => (
                    <div key={step.id} style={styles.step}>
                        <div style={{
                            ...styles.stepNumber,
                            ...(currentStep === step.id ? styles.stepNumberActive : {}),
                            ...(currentStep > step.id ? styles.stepNumberDone : {})
                        }}>
                            {currentStep > step.id ? <FaCheck /> : step.id}
                        </div>
                        <span style={{
                            ...styles.stepLabel,
                            ...(currentStep === step.id ? styles.stepLabelActive : {})
                        }}>
                            {step.label}
                        </span>
                    </div>
                ))}
            </div>

            {/* Content */}
            <div style={styles.content}>
                {currentStep === 1 && renderStep1()}
                {currentStep === 2 && renderStep2()}
                {currentStep === 3 && renderStep3()}
                {currentStep === 4 && renderStep4()}
                {currentStep === 5 && renderStep5()}
            </div>

            {/* Footer */}
            <div style={styles.footer}>
                <button 
                    style={{ ...styles.btn, ...styles.secondaryBtn }}
                    onClick={currentStep === 1 ? onClose : handleBack}
                >
                    <FaArrowLeft />
                    {currentStep === 1 ? 'Cancel' : 'Back'}
                </button>
                
                {currentStep < 5 ? (
                    <button 
                        style={{ 
                            ...styles.btn, 
                            ...styles.primaryBtn,
                            opacity: canProceed() ? 1 : 0.5,
                            cursor: canProceed() ? 'pointer' : 'not-allowed'
                        }}
                        onClick={handleNext}
                        disabled={!canProceed()}
                    >
                        Next
                        <FaArrowRight />
                    </button>
                ) : (
                    <button 
                        style={{ ...styles.btn, ...styles.successBtn }}
                        onClick={handleCreate}
                        disabled={saving}
                    >
                        <FaPaperPlane />
                        {saving ? 'Creating...' : 'Create Campaign'}
                    </button>
                )}
            </div>
        </div>
        </>
    );
};

export default CampaignWizard;
